import { Routes } from '@/router/routes'

import { Middleware } from '@/types/enums/middleware/middleware'

export const knowledgeHubRoutes = [
  {
    path: '/knowledge-hub',
    name: Routes.KnowledgeHub,
    component: () => import('@/features/knowledge-hub/KnowledgeHub.vue'),
    meta: {
      pageTitle: 'Knowledge Hub',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
    },
  },
]
